import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../services/admin.service';
import { AppConstants } from '../app.constants';

const MAX_EXPERIENCE_VALUE = 999999;
const MIN_EXPERIENCE_VALUE = 0;

@Component({
  selector: 'app-change-experience',
  templateUrl: './change-experience.component.html',
  styleUrls: ['./change-experience.component.css']
})
export class ChangeExperienceComponent {
  public id: string;
  public value: number;
  public disabledBtn = false;
  public successInfo = false;
  public errorInfo = false;
  changeLog = '';

  constructor(
    public activeModal: NgbActiveModal,
    private adminService: AdminService
  ) {}

  public get saveDisabled(): boolean {
    return this.disabledBtn || typeof this.value !== 'number' || isNaN(this.value);
  }

  public setId(id: string): void {
    this.id = id;
  }

  public setValue(value: number): void {
    this.value = value;
  }

  public change(value: number): void {
    if (value > MAX_EXPERIENCE_VALUE) {
      this.value = MAX_EXPERIENCE_VALUE;
    }
    if (value < MIN_EXPERIENCE_VALUE) {
      this.value = MIN_EXPERIENCE_VALUE;
    }
  }

  public save(): void {
    this.disabledBtn = true;
    this.successInfo = false;
    this.errorInfo = false;

    this.adminService.changeSalaryValue(this.id, this.value, this.changeLog).subscribe(
      () => {
        this.successInfo = true;
        this.disabledBtn = false;
        this.activeModal.close(AppConstants.MODAL_RESULT.OK);
      },
      () => {
        this.errorInfo = true;
        this.disabledBtn = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/change-experience/change-experience.component.ts